const renderMarkdown = (md) => {
  if (!md) return '';

  const tablePlaceholders = [];

  let processed = md.replace(/(?:^|\n)((?:\|[^\n]+\|\n?)+)/g, (match, tableBlock) => {
    const rows = tableBlock.trim().split('\n').filter(r => r.trim());
    if (rows.length < 2) return match;

    const isSeparator = (row) => /^\|[\s\-:|]+\|$/.test(row.trim());
    const parseRow = (row) => row.split('|').slice(1, -1).map(c => c.trim());

    let headerRow = null;
    const bodyRows = [];
    let i = 0;

    if (rows.length >= 2 && isSeparator(rows[1])) {
      headerRow = parseRow(rows[0]);
      i = 2;
    }

    for (; i < rows.length; i++) {
      if (!isSeparator(rows[i])) {
        bodyRows.push(parseRow(rows[i]));
      }
    }

    let html = '<div class="md-table"><table style="border-collapse:collapse;width:100%;min-width:0;margin:0;font-size:12px">';
    if (headerRow) {
      html += '<thead><tr>';
      headerRow.forEach(cell => {
        html += `<th style="border:1px solid var(--glass-border);padding:6px 10px;text-align:left;background:var(--glass-strong);color:var(--text-1);font-weight:600">${cell}</th>`;
      });
      html += '</tr></thead>';
    }
    html += '<tbody>';
    bodyRows.forEach(row => {
      html += '<tr>';
      row.forEach(cell => {
        html += `<td style="border:1px solid var(--glass-border);padding:6px 10px;color:var(--text-2)">${cell}</td>`;
      });
      html += '</tr>';
    });
    html += '</tbody></table></div>';

    const placeholder = `\n__TABLE_${tablePlaceholders.length}__\n`;
    tablePlaceholders.push(html);
    return placeholder;
  });

  let html = processed
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/^### (.+)$/gm, '<h4 style="font-size:13px;font-weight:600;color:var(--text-1);margin:16px 0 8px">$1</h4>')
    .replace(/^## (.+)$/gm, '<h3 style="font-size:15px;font-weight:600;color:var(--text-1);margin:16px 0 8px">$1</h3>')
    .replace(/^# (.+)$/gm, '<h2 style="font-size:17px;font-weight:700;color:var(--text-1);margin:16px 0 8px">$1</h2>')
    .replace(/\*\*(.+?)\*\*/g, '<strong style="font-weight:600;color:var(--text-1)">$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/`([^`]+)`/g, '<code style="padding:1px 6px;border-radius:4px;background:var(--glass-strong);color:var(--accent-1);font-size:12px;font-family:var(--mono)">$1</code>')
    .replace(/^- (.+)$/gm, '<li style="margin-left:16px;color:var(--text-2)">$1</li>')
    .replace(/^(\d+)\. (.+)$/gm, '<li style="margin-left:16px;color:var(--text-2)">$1. $2</li>')
    .replace(/\n\n/g, '<br/><br/>')
    .replace(/\n/g, '<br/>');

  tablePlaceholders.forEach((tableHtml, idx) => {
    html = html.replace(`<br/>__TABLE_${idx}__<br/>`, tableHtml);
    html = html.replace(`__TABLE_${idx}__`, tableHtml);
  });

  return html;
};

export default renderMarkdown;
